<template>
  <div id="seal">
    <!-- <h3>破产案例</h3> -->
    <el-card class="index">
      <div class="menu">
        <el-menu :default-active="$route.name" :key="key" class="el-menu-demo" mode="horizontal" @select="SelectMenu"
          router>
          <!-- <el-menu-item index="bankrupt">破产案例</el-menu-item> -->
          <el-menu-item v-for="(item, index) in targetRoutes" :key="index" :index="item.path">
            {{ item.meta.title }}
          </el-menu-item>
        </el-menu>
      </div>
      <el-button  type="success" @click="enter('seal')" v-if="!next && $route.meta.menu == 'seal'&&$store.state.rolesname.includes('sealApply')" class="btn"
     >申请用章</el-button>
      <el-button type="success" @click="enter('Bid')" v-if="!next & $route.meta.menu == 'Bid'&&$store.state.rolesname.includes('BidApply')" class="btn">审批申请</el-button>
      <!-- 折腾跳转是出现的文字 -->
      <div class="kb"></div>
      <div class="xian"></div>
      <router-view @value="getvalue"></router-view>

    </el-card>
  </div>
</template>
  
<script>
import { getmenu, changerouter } from "../../utils/seal.js";
export default {
  name: "seal",
  data() {
    return {
      next: false,
      active: "",
      array: getmenu(),
    };
  },
  methods: {
    SelectMenu(item) {
      let that = this;
      that.$router.push({
        path: `/home/seal/` + item
      });
    },
    getvalue(value) {//获取子组件的值
      this.next = value;
      // console.log("成功"+value);
    },
    enter(type) {
      let that = this;
      if (type == 'seal') {
        that.$router.push({
          path: 'sealApply'
        });
      } else if (type == "Bid") {
        that.$router.push({
          path: 'BidApply'
        });
      }


    },
  },
  created() {
  },
  computed: {
    key() {
      if (this.$route.meta.menu == "Sealdetail") {
        return "Sealdetail"
      } else if (this.$route.meta.menu == "Biddetail") {
        return "Biddetail"
      }
      else if (this.next) {
        return "sealApply"
      }
    },
    targetRoutes() {
      var target = this.array
      if(target.length>0){
        let arr = target[0].children
      // let arr =[];
      if (this.next) {
        arr = arr.filter(
          el => el.hidden == true
        )
        arr = changerouter(arr, this.$route.meta.menu)
      } else {
        arr = arr.filter(
          el => el.hidden != true
        )
      }
      return arr
    }
     
    },


  },
  watch: {
  }
};
</script>
  
<style lang="less" scoped>
#seal .index {
  width: 100%;
  margin: auto;
  border-radius: 16px;
  position: relative;
}

#seal .el-menu {
  display: flex;
  text-align: center;
  border-right: 0px;
  // margin-bottom: 5vh;
  // .el-menu-item{
  //   width:20vh;
  // }

  .el-menu-item {
    font-size: 16px;
    height: 55px;

    &:hover {
      background-color: #fff;
      color: #409eff !important;
      border-bottom: 1px solid #409eff;
    }
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    border-bottom: 1px solid #409eff;
    color: #409eff !important;
  }
}

#seal .el-menu.el-menu--horizontal {
  border-bottom: none;
}

#seal .menu {
  width: 96%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#seal /deep/.el-card__body,
#seal .el-main {
  padding: 0px;
  padding-bottom: 20px;

}

#seal .xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;

}

#seal .btn {
  position: absolute;
  top: 8px;
  right: 2%;
  z-index: 2;
  // position:absolute;
  // top:130px;
  // right: 2%;
}

#seal .kb {
  width: 98px;
  height: 48px;
  position: absolute;
  top: 8px;
  right: 2%;
  background: #fff;
  z-index: 1;
}</style>
  